import { format, parseISO } from 'date-fns';
import type { OrderStatus } from '../types/platform';

export function formatOrderDate(iso: string, pattern = 'd MMM yyyy'): string {
  return format(parseISO(iso), pattern);
}

export const orderStatusStyles: Record<OrderStatus, string> = {
  Processing: 'border-[#9b8cf0]/40 bg-[#9b8cf0]/10 text-[#c4baff]',
  'In transit': 'border-[#6fc3d3]/40 bg-[#6fc3d3]/10 text-[#6fc3d3]',
  Delivered: 'border-[#8fd3b0]/40 bg-[#8fd3b0]/10 text-[#8fd3b0]',
  Cancelled: 'border-white/15 bg-white/5 text-muted-foreground',
};
